import DemoBanner from "./DemoBanner";
import BalmEmployeeDemo from "@/pages/public/callachap/BalmEmployeeDemo";

/**
 * Care Portal wrapper for the BALM employee demo.
 * Reuses <BalmEmployeeDemo /> from /callachap/demo/balm without modification.
 * Adds a Care Portal demonstration banner and route context.
 */
export default function CareBalmEmployee() {
  return (
    <div data-testid="care-balm-employee-wrapper">
      <DemoBanner subtitle="Employee experience — no requests are transmitted or stored." />
      <BalmEmployeeDemo />
    </div>
  );
}
